'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _angularFix = require('angular-fix');

var _angularFix2 = _interopRequireDefault(_angularFix);

exports['default'] = formlyUsability;

// @ngInject
function formlyUsability(formlyApiCheck, formlyErrorAndWarningsUrlPrefix) {
  var _this = this;

  _angularFix2['default'].extend(this, {
    getFormlyError: getFormlyError,
    getFieldError: getFieldError,
    checkWrapper: checkWrapper,
    checkWrapperTemplate: checkWrapperTemplate,
    getErrorMessage: getErrorMessage,
    $get: function $get() {
      return _this;
    }
  });

  function getFieldError(errorInfoSlug, message, field) {
    if (arguments.length < 3) {
      field = message;
      message = errorInfoSlug;
      errorInfoSlug = null;
    }
    return new Error(getErrorMessage(errorInfoSlug, message) + (' Field definition: ' + _angularFix2['default'].toJson(field)));
  }

  function getFormlyError(errorInfoSlug, message) {
    if (!message) {
      message = errorInfoSlug;
      errorInfoSlug = null;
    }
    return new Error(getErrorMessage(errorInfoSlug, message));
  }

  function getErrorMessage(errorInfoSlug, message) {
    var url = '';
    if (errorInfoSlug !== null) {
      url = '' + formlyErrorAndWarningsUrlPrefix + errorInfoSlug;
    }
    return 'Formly Error: ' + message + '. ' + url;
  }

  function checkWrapper(wrapper) {
    formlyApiCheck['throw'](formlyApiCheck.formlyWrapperType, wrapper, {
      prefix: 'formlyConfig.setWrapper',
      urlSuffix: 'setwrapper-validation-failed'
    });
  }

  function checkWrapperTemplate(template, additionalInfo) {
    var formlyTransclude = '<formly-transclude></formly-transclude>';
    if (template.indexOf(formlyTransclude) === -1) {
      throw getFormlyError('Template wrapper templates must use "' + formlyTransclude + '" somewhere in them. ' + ('This one does not have "<formly-transclude></formly-transclude>" in it: ' + template) + '\n' + ('Additional information: ' + JSON.stringify(additionalInfo)));
    }
  }
}
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./providers/formlyUsability.js
 **/